export function setStlCookie() {
  const date = new Date(Date.now() + 2 * 60 * 60 * 1000).toUTCString()
  const domain = window.location.hostname.split('.').slice(-2).join('.') // Note: does not work for .co.uk domains
  document.cookie = `stl=true;expires=${date};domain=${domain};path=/;SameSite=Strict`
}
